export default __webpack_public_path__ + "static/media/quiz_bg_1.4c14b2c5.png";